import React from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';

const PriveLounge = () => {
  const navigate = useNavigate();

  const services = [
    {
      icon: '📅',
      title: 'Make a Reservation',
      description: 'Book your table at Privé Lounge',
      route: '/restaurant-booking'
    },
    {
      icon: '🍽️',
      title: 'Dine-In Ordering',
      description: 'Order from your table using your table code',
      route: '/restaurant-order'
    },
    {
      icon: '📋',
      title: 'My Orders',
      description: 'View active orders and order history',
      route: '/restaurant-orders'
    }
  ];

  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Privé Private Wealth Club</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Exclusive Membership & Elite Services</p>
        
        <div className="card" style={{ marginBottom: '2rem' }}>
          <p>
            Experience the pinnacle of luxury and exclusive wealth management services. 
            Join an elite community of high-net-worth individuals worldwide. Enjoy exclusive 
            access to our restaurant reservations and premium dining experiences.
          </p>
        </div>

        {/* Service Cards */}
        <div className="service-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card"
              onClick={() => navigate(service.route)}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <div className="service-arrow">→</div>
            </div>
          ))}
        </div>

        <div className="card" style={{ marginTop: '2rem' }}>
          <div className="service-features">
            <div className="feature-item">
              <h3>Private Advisory</h3>
              <p>One-on-one wealth management consultations</p>
            </div>
            <div className="feature-item">
              <h3>Elite Networking</h3>
              <p>Access to exclusive events and opportunities</p>
            </div>
            <div className="feature-item">
              <h3>Global Concierge</h3>
              <p>24/7 luxury concierge services worldwide</p>
            </div>
            <div className="feature-item">
              <h3>Premium Dining</h3>
              <p>Exclusive restaurant reservations and experiences</p>
            </div>
          </div>
        </div>
      </div>
      <BottomNav />
    </div>
  );
};

export default PriveLounge;
